export enum MaterialType {
  Wood = "wood",
  Stone = "stone",
  Glass = "glass",
  Materia = "materia",
  Metal = "metal",
}
